import React, {useEffect, useState} from "react";
import {css} from "@panda/css";

import {Button} from "@pg-design/button-module";
import {Loader} from "@pg-design/loader-module";
import {Text} from "@pg-design/text-module";

import {OfferDisplayType} from "../../../offer/helpers/OfferDisplayType";
import {OfferType} from "../../../offer/types/OfferType";
import {IVendorOfferWithoutVendorConfiguration} from "../../../offer/types/VendorOffersListResponse";
import {useAppDispatch, useAppSelector} from "../../../store/hooks";
import {useGetVendorDetailOffersQuery} from "../../api/get_vendor_detail_offers";
import {VendorDetailSoldOffersPageSize} from "../../constants/VendorDetailSoldOffersPageSize";
import {resetSoldOffersPage, setSoldOffersNextPage} from "../../state/vendor_offer_list_slice";
import {IVendorDetail} from "../../types/IVendorDetail";
import {convertToVendorDetailViewOffersPayload} from "../../utils/convert_to_vendor_detail_view_offers_payload";
import {generalSectionStyle} from "../../views/VendorDetailView";
import {VendorDetailSoldOfferBox, VendorDetailSoldOfferBoxProps} from "./boxes/VendorDetailSoldOfferBox";

interface ISoldOffer {
    vendorSlug: VendorDetailSoldOfferBoxProps["vendorSlug"];
    vendorDetail: IVendorDetail;
}

interface ISoldOfferList extends Omit<ISoldOffer, "vendorDetail"> {
    offers: IVendorOfferWithoutVendorConfiguration[];
}

const VendorDetailSoldList: React.FC<ISoldOfferList> = ({vendorSlug, offers}) => (
    <ul className={soldOffersListStyle}>
        {offers.map((offer) => (
            <li key={offer.id} className={listItemStyle}>
                <VendorDetailSoldOfferBox offer={offer} vendorSlug={vendorSlug} />
            </li>
        ))}
    </ul>
);

export const VendorDetailSoldOffers = (props: ISoldOffer) => {
    const {vendorSlug, vendorDetail} = props;
    const dispatch = useAppDispatch();
    const [visibleSoldOffers, setVisibleSoldOffers] = useState<IVendorOfferWithoutVendorConfiguration[]>([]);
    const page = useAppSelector((state) => state.vendorDetailViewSlice.soldOffersListParams.page);
    const region = useAppSelector((state) => state.vendorDetailViewSlice.activeOffersListParams.region);

    const fullQuerySoldOffers = {
        ...convertToVendorDetailViewOffersPayload({vendorId: vendorDetail.id, region: region, displayType: OfferDisplayType.SOLD}),
        limited_presentation: undefined,
        page_size: VendorDetailSoldOffersPageSize,
        page,
        type: [OfferType.FLAT, OfferType.HOUSE]
    };
    const {data: soldOffers, isFetching} = useGetVendorDetailOffersQuery(fullQuerySoldOffers);

    const soldOffersCount = soldOffers?.count || 0;

    useEffect(() => {
        if (soldOffers?.results && page > 1) {
            setVisibleSoldOffers((prevOffers) => [...prevOffers, ...soldOffers.results]);
        }
        if (soldOffers?.results && page === 1) {
            setVisibleSoldOffers(soldOffers.results);
        }
    }, [soldOffers]);

    if (soldOffersCount <= 0 && !isFetching) {
        return null;
    }

    return (
        <section className={generalSectionStyle}>
            {soldOffersCount > 0 && (
                <Text as="h2" variant="headline_3" className={headingStyle}>
                    {vendorDetail.name} - Inwestycje zrealizowane
                </Text>
            )}

            {visibleSoldOffers.length > 0 && <VendorDetailSoldList offers={visibleSoldOffers} vendorSlug={vendorSlug} />}

            <div className={css({pt: 2})}>
                {isFetching && <Loader size="md" className={loaderStyle} />}

                {!isFetching && soldOffersCount > VendorDetailSoldOffersPageSize * page && (
                    <Button variant="highlight_primary" onClick={() => dispatch(setSoldOffersNextPage())}>
                        Zobacz więcej
                    </Button>
                )}

                {soldOffersCount > VendorDetailSoldOffersPageSize && soldOffersCount <= VendorDetailSoldOffersPageSize * page && (
                    <Button variant="highlight_primary" onClick={() => dispatch(resetSoldOffersPage())}>
                        Pokaż mniej
                    </Button>
                )}
            </div>
        </section>
    );
};

const headingStyle = css({
    marginBottom: 0.5
});

const soldOffersListStyle = css({
    listStyle: "none",
    paddingLeft: 0,
    margin: 0
});

const listItemStyle = css({
    marginTop: 2,
    marginBottom: 2,
    md: {
        marginTop: 3,
        marginBottom: 3
    }
});

const loaderStyle = css({
    display: "flex",
    justifyContent: "center",
    marginTop: 3,
    marginBottom: 3
});
import React, {useEffect, useState} from "react";
import {css} from "@panda/css";

import {Button} from "@pg-design/button-module";
import {Loader} from "@pg-design/loader-module";
import {Text} from "@pg-design/text-module";

import {OfferDisplayType} from "../../../offer/helpers/OfferDisplayType";
import {OfferType} from "../../../offer/types/OfferType";
import {IVendorOfferWithoutVendorConfiguration} from "../../../offer/types/VendorOffersListResponse";
import {useAppDispatch, useAppSelector} from "../../../store/hooks";
import {useGetVendorDetailOffersQuery} from "../../api/get_vendor_detail_offers";
import {VendorDetailSoldOffersPageSize} from "../../constants/VendorDetailSoldOffersPageSize";
import {resetSoldOffersPage, setSoldOffersNextPage} from "../../state/vendor_offer_list_slice";
import {IVendorDetail} from "../../types/IVendorDetail";
import {convertToVendorDetailViewOffersPayload} from "../../utils/convert_to_vendor_detail_view_offers_payload";
import {generalSectionStyle} from "../../views/VendorDetailView";
import {VendorDetailSoldOfferBox, VendorDetailSoldOfferBoxProps} from "./boxes/VendorDetailSoldOfferBox";

interface ISoldOffer {
    vendorSlug: VendorDetailSoldOfferBoxProps["vendorSlug"];
    vendorDetail: IVendorDetail;
}

interface ISoldOfferList extends Omit<ISoldOffer, "vendorDetail"> {
    offers: IVendorOfferWithoutVendorConfiguration[];
}

const VendorDetailSoldList: React.FC<ISoldOfferList> = ({vendorSlug, offers}) => (
    <ul className={soldOffersListStyle}>
        {offers.map((offer) => (
            <li key={offer.id} className={listItemStyle}>
                <VendorDetailSoldOfferBox offer={offer} vendorSlug={vendorSlug} />
            </li>
        ))}
    </ul>
);

export const VendorDetailSoldOffers = (props: ISoldOffer) => {
    const {vendorSlug, vendorDetail} = props;
    const dispatch = useAppDispatch();
    const [visibleSoldOffers, setVisibleSoldOffers] = useState<IVendorOfferWithoutVendorConfiguration[]>([]);
    const page = useAppSelector((state) => state.vendorDetailViewSlice.soldOffersListParams.page);
    const region = useAppSelector((state) => state.vendorDetailViewSlice.activeOffersListParams.region);

    const fullQuerySoldOffers = {
        ...convertToVendorDetailViewOffersPayload({vendorId: vendorDetail.id, region: region, displayType: OfferDisplayType.SOLD}),
        limited_presentation: undefined,
        page_size: VendorDetailSoldOffersPageSize,
        page,
        type: [OfferType.FLAT, OfferType.HOUSE]
    };
    const {data: soldOffers, isFetching} = useGetVendorDetailOffersQuery(fullQuerySoldOffers);

    const soldOffersCount = soldOffers?.count || 0;

    useEffect(() => {
        if (soldOffers?.results && page > 1) {
            setVisibleSoldOffers((prevOffers) => [...prevOffers, ...soldOffers.results]);
        }
        if (soldOffers?.results && page === 1) {
            setVisibleSoldOffers(soldOffers.results);
        }
    }, [soldOffers]);

    if (soldOffersCount <= 0 && !isFetching) {
        return null;
    }

    return (
        <section className={generalSectionStyle}>
            {soldOffersCount > 0 && (
                <Text as="h2" variant="headline_3" className={headingStyle}>
                    {vendorDetail.name} - Inwestycje zrealizowane
                </Text>
            )}

            {visibleSoldOffers.length > 0 && <VendorDetailSoldList offers={visibleSoldOffers} vendorSlug={vendorSlug} />}

            <div className={css({pt: 2})}>
                {isFetching && <Loader size="md" className={loaderStyle} />}

                {!isFetching && soldOffersCount > VendorDetailSoldOffersPageSize * page && (
                    <Button variant="highlight_primary" onClick={() => dispatch(setSoldOffersNextPage())}>
                        Zobacz więcej
                    </Button>
                )}

                {soldOffersCount > VendorDetailSoldOffersPageSize && soldOffersCount <= VendorDetailSoldOffersPageSize * page && (
                    <Button variant="highlight_primary" onClick={() => dispatch(resetSoldOffersPage())}>
                        Pokaż mniej
                    </Button>
                )}
            </div>
        </section>
    );
};

const headingStyle = css({
    marginBottom: 0.5
});

const soldOffersListStyle = css({
    listStyle: "none",
    paddingLeft: 0,
    margin: 0
});

const listItemStyle = css({
    marginTop: 2,
    marginBottom: 2,
    md: {
        marginTop: 3,
        marginBottom: 3
    }
});

const loaderStyle = css({
    display: "flex",
    justifyContent: "center",
    marginTop: 3,
    marginBottom: 3
});
